import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    teamFilterData: []
}
const TeamFilterSlice = createSlice({
    name: 'teamFilterFields',
    initialState,
    reducers: {
        handleTeamFilterData(state, action) {
            state.teamFilterData = action.payload
        }
    }
})
export const { handleTeamFilterData } = TeamFilterSlice.actions
export default TeamFilterSlice.reducer